export const iconFontAwesomeAutomotiveTrailer = (
	<i className="fa-solid fa-trailer"></i>
);
